/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem } from './interface/searchable.item';
import { SearchableSelectionType } from './interface/searchable.selection';

export class State implements SearchableItem {
  ID: string;
  NAME: string;
  DESCRIPTION: string;

  // Helpers
  active = false;
  selected = false;
  allowed = false;

  static parse(json: any): State {
    if (json) {
      const s = new State();

      s.ID = json.ID;
      s.NAME = json.NAME;
      s.DESCRIPTION = json.DESCRIPTION;

      return s;
    } else return null;
  }

  static parseArray(json: any[]): State[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(State.parse(j));

    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
